import { AppThunk } from 'app/store'
import { parseError } from 'utils/errors'
import { list, create, remove } from 'services/carrierInvite'
import { showMessage } from 'features/message/actions'

import { slice } from './reducer'

export const {
  createInviteFailed,
  createInviteStart,
  createInviteSuccess,
  deleteInviteFailed,
  deleteInviteStart,
  deleteInviteSuccess,
  fetchInvitesFailed,
  fetchInvitesStart,
  fetchInvitesSuccess,
} = slice.actions

export const fetchInvites = (rfpId: string | number): AppThunk => async (
  dispatch
) => {
  dispatch(fetchInvitesStart())
  try {
    const data = await list(rfpId)
    dispatch(
      fetchInvitesSuccess({
        invites: data.carrierInvites,
        carriers: data.carriers,
      })
    )
  } catch (err) {
    dispatch(fetchInvitesFailed())
  }
}

export const createInvite = (
  carrier: Carrier,
  invite: Omit<CarrierInvite, 'id' | 'meta'>
): AppThunk => async (dispatch) => {
  dispatch(createInviteStart({ carrier, invite }))
  try {
    const data = await create(invite)
    dispatch(
      createInviteSuccess({
        carrier: data.carrier,
        invite: {
          ...data,
          email_sent_at: data.invite_email_sent_at,
          carrier: carrier.id,
        },
      })
    )
  } catch (error) {
    const errorMessage = parseError(error)
    dispatch(createInviteFailed({ invite, error: errorMessage }))
    dispatch(
      showMessage(
        {
          message: errorMessage,
          type: 'error',
        },
        8000
      )
    )
  }
}

export const deleteInvite = (
  carrier: Carrier,
  invite: CarrierInvite
): AppThunk => async (dispatch) => {
  dispatch(deleteInviteStart({ carrier, invite }))
  try {
    await remove(invite)
    dispatch(deleteInviteSuccess(invite))
  } catch (error) {
    const errorMessage = parseError(error)
    dispatch(deleteInviteFailed({ carrier, invite, error: errorMessage }))
    dispatch(
      showMessage(
        {
          message: errorMessage,
          type: 'error',
        },
        8000
      )
    )
  }
}

export const toggleCarrierInvite = (
  carrier: Carrier,
  rfpId: number,
  isSelected: boolean
): AppThunk => (dispatch) => {
  const invite = {
    rfp: rfpId,
    carrier: carrier.id,
    rate_type: 'all_in_rate',
    email_sent_at: null,
    id: carrier.invite,
  } as CarrierInvite

  if (isSelected) {
    dispatch(deleteInvite(carrier, invite))
  } else {
    dispatch(createInvite(carrier, invite))
  }
}
